export default __webpack_public_path__ + "static/media/searchheader.7ac5c5ef.svg";